import { usePageHeader } from "@hooks/use_page_header";
import moment from "moment-timezone";
import { useLocation } from "react-router-dom";
import { LuCalendar, LuFileText, LuGift, LuTrophy } from "react-icons/lu";

moment.locale("id");

type InfoRowProps = { label: string; value: React.ReactNode };
const InfoRow = ({ label, value }: InfoRowProps) => (
  <div className="tw-flex tw-justify-between tw-items-start tw-py-2.5 tw-gap-3">
    <span className="tw-text-xs tw-text-text-secondary tw-shrink-0 tw-w-2/5">{label}</span>
    <span className="tw-text-sm tw-font-semibold tw-text-text-primary tw-text-right tw-flex-1">
      {value}
    </span>
  </div>
);

const Divider = () => <div className="tw-h-px" style={{ background: "#f1f1f1" }} />;

export const AchievementDetailPage = () => {
  const { state } = useLocation();
  usePageHeader("Detail Prestasi", { bottomNavigation: "hidden" });

  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-20 tw-space-y-3">

      {/* Hero card */}
      <div className="card-body tw-text-center tw-py-6">
        <div
          className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-3xl tw-w-16 tw-h-16 tw-mb-4"
          style={{ background: "#fffbeb" }}
        >
          <LuTrophy className="tw-text-3xl tw-text-[#f59e0b]" />
        </div>

        <div className="tw-text-lg tw-font-bold tw-text-text-primary tw-mb-2 tw-px-4">
          {state?.prestasi ?? "-"}
        </div>

        <div className="tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-text-xs tw-text-text-secondary tw-mb-3">
          <LuCalendar className="tw-text-sm" />
          {moment(state?.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
        </div>

        <div
          className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-4 tw-py-1.5 tw-rounded-full tw-text-sm tw-font-bold"
          style={{ background: "#fffbeb", color: "#b45309", border: "1.5px solid #fde68a" }}
        >
          <LuTrophy className="tw-text-base" />
          +{state?.poin ?? 0} poin
        </div>
      </div>

      {/* Detail card */}
      <div className="card-body">
        <div className="tw-flex tw-items-center tw-gap-2 tw-mb-3">
          <div className="tw-w-1 tw-h-4 tw-rounded-full tw-bg-primary" />
          <span className="tw-text-xs tw-font-bold tw-text-text-secondary tw-uppercase tw-tracking-widest">
            Rincian Prestasi
          </span>
        </div>

        <InfoRow
          label="Reward"
          value={
            <span className="tw-flex tw-items-center tw-justify-end tw-gap-1.5">
              <LuGift className="tw-text-text-secondary tw-shrink-0" />
              {state?.reward ?? "-"}
            </span>
          }
        />

        {state?.catatan && state.catatan !== "-" && (
          <>
            <Divider />
            <div className="tw-pt-2.5 tw-pb-1">
              <div className="tw-flex tw-items-center tw-gap-1.5 tw-mb-1.5">
                <LuFileText className="tw-text-sm tw-text-text-secondary" />
                <span className="tw-text-xs tw-text-text-secondary">Catatan</span>
              </div>
              <p className="tw-text-sm tw-font-semibold tw-text-text-primary tw-leading-relaxed">
                {state.catatan}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
